
import React, { useEffect,  useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {  getContentsClientBySection } from "../../store/actions/CreateCourse/CourseApi";
import { AudioWaveform, Blocks, ChevronDown, Fan, Folder, Info, Video } from "lucide-react";
import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import PlayerPageCardFolderContents from "./PlayerPageCardFoldersContents";
import PlayerPageChapterCard from "./PlayerPageChapterCard";

const PlayerPageCardSectionsContents =({courseId,playerCard1Object,setCurrentItem,sectionId,progress=20})=>{
   const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    
    </div>
  );
};
        const showProgress = typeof progress === 'number' && progress >= 0 && progress <= 100;

      
  const [toggleState , setToggleState] =useState(false)
  const [theme , setTheme] =useState("")
        const [itemArr, setItemArr] = useState([]);
               const [counts, setCounts] = useState({});
               
                       const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{}]);
               
      const [sort, setSort] = useState("ASC");
               const [pageNo, setPageNo] = useState(1);
               const [limit, setLimit] = useState(10);
             const [dropDownVal, setDropDownVal] = useState("Active");
                const [startDate, setStartDate] = useState(null);
          
            const [endDate, setEndDate] = useState(null);
      const [advancedFilters , setAdvancedFilters] =useState(true)
         const [toggleStatePaid , setToggleStatePaid] =useState(null)
         const [toggleStateLifetime , setToggleStateLifetime] =useState(null)
       
       const dispatch = useDispatch();
                const user = useSelector((state)=>state?.user?.user);
                     
                const [snackbarVisible, setSnackbarVisible] = useState(false);
                                 const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                                 const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                           
                                  
                              const showSnackbar = () => {
                                setSnackbarVisible(true);
                              };
                             
                              const hideSnackbar = () => {
                                setSnackbarVisible(false);
                              };
                        
                        
                                   
                                   
                                
                               const [animate, setAnimate] = useState(false);
                 
                  const [loader , setLoader] =useState({status:true});
         
             
                    const currentToken = useSelector((state)=>state?.user?.user?.currentToken);
                    const userEmail = useSelector((state)=>state?.user?.user?.userData?.userEmail
                   );
                   
                       const userData =useSelector((state)=>state?.user?.user);
                      const AppToken = useSelector((state)=>state?.user?.user?.appToken);
                      const appId = useSelector((state)=>state?.user?.user?.appId);
                    
                              
           
         const fireGetContentsClientBySection=()=>{
                setItemArr([])
                 
             
               setItemArrLoading([{},{},{},{}])
               setLoader({status:true});
                     const apiData = dispatch(getContentsClientBySection({userEmail:userEmail?userEmail:"",
            currentToken:currentToken?currentToken:"",productType:"course", courseId:courseId,postParent:sectionId}));
                     /* get response as Promise   */
                     apiData.then(response => {
                    //  console.log(response)
               
                       if(response?.contents){
                       setItemArr(response?.contents);
               setItemArrLoading([])
                       setResponseMessage(response?.message);
                       setSnackbarColor("rgba(144, 202, 249,1)");
                     
                   setLoader({status:false});
                   
                   // setSnackbarVisible(true);
                   setTimeout(()=>{
                     
                     setSnackbarVisible(false);
                   },1000)
                   
                         
                       
                      if(response?.logout){
                      
                       setResponseMessage("You are Logged Out!!!");
                         
                       setSnackbarColor("#958FDA");
                     
                       
                        
                   setLoader({status:false});
                   
                   setSnackbarVisible(true);
                   setTimeout(()=>{
                     
                     setSnackbarVisible(false);
                    
                      
                   },3000)
                       setTimeout(()=>{
                         dispatch({type:"LOGOUT"});
                   
                       },3000)
                       
                     }
                   
                       }else{
                         setResponseMessage("Something Went Wrong...");
                         
                         setSnackbarColor("#958FDA");
                       
                          
                     setLoader({status:false});
                     
                     setSnackbarVisible(true);
                     setTimeout(()=>{
                       
                       setSnackbarVisible(false);
                      
                        
                     },3000)    }
                   
                     }).catch(error => {
                    
                       //popup of error Info
                       setResponseMessage("Something Went Wrong...");
                         
                       setSnackbarColor("#958FDA");
                    
                       
                        
                   setLoader({status:false});
                   
                   setSnackbarVisible(true);
                   setTimeout(()=>{
                     
                     setSnackbarVisible(false);
                    
                      
                   },3000)
                      
                     });
                }
       
     
     useEffect(()=>{fireGetContentsClientBySection()},[])
       const flattenedData = itemArr!=[]?Object.values(itemArr):'';
     
              const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
      
    return(<> {flattenedDataLoading?.length==0?flattenedData?.length?
flattenedData?.map((item,index)=>(<div key={index} style={{background:`${playerCard1Object?.chapter?.bgColor?.color}`,
border:` ${playerCard1Object?.chapter?.border?.borderWidth?.value+playerCard1Object?.chapter?.border?.borderWidth?.resolution} ${playerCard1Object?.chapter?.border?.borderType}  ${playerCard1Object?.chapter?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${playerCard1Object?.chapter?.borderRadius?.topLeft?.value}${playerCard1Object?.chapter?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.chapter?.borderRadius?.topRight?.value}${playerCard1Object?.chapter?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.chapter?.borderRadius?.bottomLeft?.value}${playerCard1Object?.chapter?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.chapter?.borderRadius?.bottomRight?.value}${playerCard1Object?.chapter?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px",padding:"5px",marginTop:"10px"}}>
    {item?.postType=="chapter"?<div>
   <PlayerPageChapterCard  courseId={courseId} playerCard1Object={playerCard1Object} setCurrentItem={(v)=>{setCurrentItem(v)}} contentItem={item} /></div>:item?.postType=="folder"?<div>
<PlayerPageCardFolderContents courseId={courseId} playerCard1Object={playerCard1Object} setCurrentItem={(v)=>{setCurrentItem(v)}} folderItem={item} />
   </div>:""}</div>)):"":""}
    </>)
}
export default PlayerPageCardSectionsContents